// extracted by mini-css-extract-plugin
export default {"btn":"BtnTertiaty_btn__n1HeW","rowIcon":"BtnTertiaty_rowIcon__yMH0x"};